import { WorkspaceMemberRole as WorkspaceMemberRoleEnum } from "@/api/__generated__/models";

export function WorkspaceMemberRoleLabel({ role }: { role: WorkspaceMemberRoleEnum }) {
  return {
    [WorkspaceMemberRoleEnum.OWNER]: "Owner",
    [WorkspaceMemberRoleEnum.ADMIN]: "Admin",
    [WorkspaceMemberRoleEnum.MEMBER]: "Member",
  }[role];
}
